module.exports = "/_next/static/images/viva-leisure-57e3dd3d1bf41e2020a31297c2aefe1c.png";